import { render, staticRenderFns } from "./CreateEventModal.vue?vue&type=template&id=7345bd0b&scoped=true"
import script from "./CreateEventModal.vue?vue&type=script&lang=js"
export * from "./CreateEventModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEventModal.vue?vue&type=style&index=0&id=7345bd0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7345bd0b",
  null
  
)

export default component.exports